export default "__VITE_ASSET__DLjPI8xu__"